/**
 * Память выбора «по участникам» и числа участников на экране «Распознавание».
 *
 * Обращение dc8fa56e (08.10.2026): человек перед каждой записью выставлял одно
 * и то же. У файла и ссылки выбор свой — у них разные значения по умолчанию
 * (ссылка без галочки идёт в parakeet с его 25 языками), и общий ключ
 * протащил бы «по участникам» из файла в ссылку.
 */
const KEY = 'recognitionSpeakerSettings';
const COUNTS = ['numSpeakers', 'minSpeakers', 'maxSpeakers'];

/** Числа участников, которые предлагает выбор (SpeakerSettings); «Авто» — это null. */
export const SPEAKER_COUNTS = [2, 3, 4, 5, 6, 7, 8, 9, 10, 12, 15, 20];

/**
 * Сохранённый выбор поверх значений по умолчанию. Каждое поле проверяется
 * отдельно: число уходит в запрос к распознаванию как есть, и мусор из
 * хранилища (старая версия, ручная правка) туда попасть не должен.
 * @param {'file'|'link'} kind
 */
export function loadSpeakerSettings(kind, defaults) {
  let saved = null;
  try {
    saved = JSON.parse(localStorage.getItem(`${KEY}.${kind}`));
  } catch {
    return defaults;
  }
  if (!saved || typeof saved !== 'object') return defaults;
  const result = { ...defaults };
  if (typeof saved.diarize === 'boolean') result.diarize = saved.diarize;
  for (const field of COUNTS) {
    if (saved[field] === null || SPEAKER_COUNTS.includes(saved[field])) result[field] = saved[field];
  }
  return result;
}

/** Запомнить выбор; недоступное хранилище (приватный режим, переполнение) — не ошибка. */
export function saveSpeakerSettings(kind, settings) {
  try {
    localStorage.setItem(`${KEY}.${kind}`, JSON.stringify({
      diarize: settings.diarize,
      numSpeakers: settings.numSpeakers,
      minSpeakers: settings.minSpeakers,
      maxSpeakers: settings.maxSpeakers,
    }));
  } catch {
    // живём без памяти
  }
}
